import { z } from "zod"

export const calliopeUserSchema = z.object({
  created_at: z.coerce.date().optional(),
  cognito_user_id: z.string().nullable(),
  connect_user_id: z.string(),
  email: z.email(),
  groups: z.array(z.string()),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  queues: z.array(z.string()),
  routing_profile_id: z.string().nullable(),
  status: z.enum([
    "ARCHIVED",
    "COMPROMISED",
    "CONFIRMED",
    "EXTERNAL_PROVIDER",
    "FORCE_CHANGE_PASSWORD",
    "RESET_REQUIRED",
    "NOT_FOUND", // for users not found in Cognito
    "UNCONFIRMED",
    "UNKNOWN",
  ]),
  updated_at: z.coerce.date().optional(),
})

export type UserListItem = z.infer<typeof calliopeUserSchema>

export const updateUserRoutingProfileSchema = z.object({
  routing_profile_id: z.string(),
})

export const routingProfileSchema = z.object({
  id: z.string(),
  name: z.string(),
  queues: z.array(z.string()),
  description: z.string().nullable(),
  number_of_users: z.number().nullable(),
})

export type RoutingProfile = z.infer<typeof routingProfileSchema>
